import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { CustomPanel, ImageContainer, PageHeader, UploadFileBtn } from '../../../../components'
import { urlUploadNfDevolucaoTotal } from '../../../../services/api/routes/receive-vehicle.routes'
import * as RetornoHttp from '../../../../services/api/https/deliveries/retorno.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { atualizarDeliveryInvoicePathAndNumber } from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'

function NotaFiscalEntrega({ history, dispatch }) {
  // Vars
  const { razao_social, identifier, delivery_id, path_nf_dev_total, invoice_number_entrega } =
    history.location.state
  // Hooks
  const [nfDevTotalPath, setNfDevTotalPath] = useState(path_nf_dev_total)

  // Events
  const onUploadCompleted = async file_name => {
    try {
      const delivery = await atualizarDeliveryInvoicePathAndNumber(
        delivery_id,
        file_name,
        invoice_number_entrega,
      )
      setNfDevTotalPath(delivery.path_nf_dev_total)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onNotaFiscalDeleted = async () => {
    try {
      const path_array = nfDevTotalPath.split('/')
      const file_name = path_array[path_array.length - 1]
      await RetornoHttp.deleteDeliveryNfDevolucaoTotalFile(file_name)
      await atualizarDeliveryInvoicePathAndNumber(delivery_id, null, invoice_number_entrega)
      setNfDevTotalPath(null)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  // Helpers

  // Render
  return (
    <React.Fragment>
      <PageHeader>
        Nota Fiscal Devolução Total &nbsp;
        <strong>
          {identifier} - {razao_social}
        </strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div style={{ height: 50 }}>
            <UploadFileBtn
              label="Anexar NF Devolução Total"
              name="nf-dev-total"
              url={urlUploadNfDevolucaoTotal(delivery_id)}
              onUploadCompleted={onUploadCompleted}
            />
          </div>
          <div>
            {nfDevTotalPath ? (
              <ImageContainer
                imagePath={nfDevTotalPath}
                alt="Nota Fiscal de Devolução Total"
                onBtnDeleteClicked={onNotaFiscalDeleted}
              />
            ) : null}
          </div>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

export default connect()(withRouter(NotaFiscalEntrega))
